module.exports = __webpack_public_path__ + "img/share_twitter_hover.85d41676.svg";